import React, { useState, useEffect, useMemo } from 'react';
import { 
  LayoutDashboard, Users, Package, FileText, Settings as SettingsIcon, Plus, Search, Trash2, 
  Save, X, Mail, Phone, DollarSign, ChevronLeft, Filter, Upload, Edit, Download, Database, 
  RefreshCw, Globe, User, CheckCircle, Send, ArrowLeft, ArrowRight, BarChart3, LogOut, Shield, 
  Cloud, FileSpreadsheet, Loader, Copy, Sun, Moon, MessageCircle, FileX, Bell, Clock, 
  AlertCircle, Check, MapPin, Hash, UserCheck, Smartphone, Tag
} from 'lucide-react';
import { THEMES, HOSTINGER_API_URL, CATEGORY_SORT_ORDER, DEFAULT_CATEGORIES, DEFAULT_TERMS, COMPANY_INFO, STATUS_OPTIONS } from '../config/constants';
import { apiCall } from '../services/api';

const BackgroundOrbs = () => (
  <div className="fixed inset-0 overflow-hidden pointer-events-none -z-10 bg-[#f8fafc]">
    <div className="absolute top-[-10%] left-[-10%] w-[50vw] h-[50vw] bg-blue-300/20 rounded-full blur-[100px] animate-pulse" style={{ animationDuration: '8s' }} />
    <div className="absolute bottom-[-10%] right-[-10%] w-[50vw] h-[50vw] bg-orange-300/20 rounded-full blur-[100px] animate-pulse" style={{ animationDuration: '10s', animationDelay: '1s' }} />
    <div className="absolute top-[30%] left-[30%] w-[40vw] h-[40vw] bg-white/60 rounded-full blur-[80px]" />
    <style dangerouslySetInnerHTML={{ __html: `
      @keyframes blink-blue { 0%, 100% { box-shadow: 0 0 15px rgba(59, 130, 246, 0.4); } 50% { box-shadow: 0 0 30px rgba(59, 130, 246, 0.8); } }
      @keyframes blink-orange { 0%, 100% { box-shadow: 0 0 15px rgba(249, 115, 22, 0.4); } 50% { box-shadow: 0 0 30px rgba(249, 115, 22, 0.8); } }
      @keyframes blink-red { 0%, 100% { box-shadow: 0 0 15px rgba(239, 68, 68, 0.4); } 50% { box-shadow: 0 0 30px rgba(239, 68, 68, 0.8); } }
      .animate-blink-blue { animation: blink-blue 2s infinite ease-in-out; }
      .animate-blink-orange { animation: blink-orange 1.5s infinite ease-in-out; }
      .animate-blink-red { animation: blink-red 1s infinite ease-in-out; }
    `}} />
  </div>
);

export default BackgroundOrbs;
